<div class="change-phone">
  <h2 class="change-phone__title">Change Phone Number</h2>

  <div class="form-container">
    <form
      [formGroup]="validateForm"
      (ngSubmit)="onSubmit()"
      class="change-phone__form"
    >
    <div class="change-phone__form-item">
      <label class="change-phone__label">Phone</label>
      <div class="change-phone__phone-input">
        <nz-select
          nztype="primary"
          [formControl]="validateForm.controls['countryCode']"
          [nzCustomTemplate]="dialingCodeTemplate"
          class="change-phone__dialcode-select"
          nzPlaceHolder="Dial Code"
          nzShowSearch
          [ngClass]="{
            'border-error':
              validateForm.controls['countryCode'].invalid &&
              validateForm.controls['countryCode'].touched,
          }"
        >
          <nz-option
            nzCustomContent
            *ngFor="let country of countryList"
            [nzValue]="country.code"
            [nzLabel]="country.dialingCode"
          >
            <div nz-flex nzAlign="center" nzGap="8px">
              <div [innerHTML]="country.flag" class="change-phone__flag-icon"></div>
              <span>{{ country.dialingCode }}</span>
            </div>
          </nz-option>
        </nz-select>

        <nz-input-group>
          <input
            nztype="primary"
            nz-input
            [placeholder]="placeholder"
            formControlName="phone"
            class="change-phone__input beta"
            [mask]="
              getPhoneMaskForCountry(
                validateForm.controls['countryCode'].value
              )
            "
            [ngClass]="{
              'border-error':
                (validateForm.controls['phone'].invalid &&
                  validateForm.controls['phone'].touched &&
                  !validateForm.controls['phone'].hasError('invalidPhone')) ||
                (validateForm.controls['phone'].touched &&
                  validateForm.controls['phone'].hasError('invalidPhone')),
            }"
          />
        </nz-input-group>
      </div>
      <div
        *ngIf="
          validateForm.controls['countryCode'].invalid &&
          validateForm.controls['countryCode'].touched
        "
        class="change-phone__form__error"
      >
        * Country selection is required
      </div>
      <div
        *ngIf="
          validateForm.controls['phone'].touched &&
          validateForm.controls['phone'].invalid &&
          !validateForm.controls['phone']?.hasError('invalidPhone')
        "
        class="change-phone__form__error"
      >
        * Phone number is required
      </div>
      <div
        *ngIf="
          validateForm.controls['phone'].touched &&
          validateForm.controls['phone']?.hasError('invalidPhone')
        "
        class="change-phone__form__error"
      >
        Invalid phone number for selected country code.
      </div>
    </div>

      <button
        nz-button
        nzType="primary"
        htmlType="submit"
        class="change-phone__button"
      >
        Update
      </button>
    </form>
  </div>

  <p class="change-phone__note">
    * You will receive a verification code via SMS. Ensure you have access to
    this number. The verification code is valid for 10 minutes. If you don't
    receive the code, click "Resend Code."
  </p>
  <p class="change-phone__note">
    Standard SMS charges may apply. If you don't verify within 3 hours, your
    account will be deleted.
  </p>
</div>

<ng-template #dialingCodeTemplate let-selected>
  <div class="change-phone__select-wrapper" *ngIf="selected.nzValue">
    <div
      [innerHTML]="getFlagByCode(selected.nzValue)"
      class="change-phone__select-flag"
    ></div>
    <span>{{ getDialingCodeByCountryCode(selected.nzValue) }}</span>
  </div>
</ng-template>
